/**
 * @generated SignedSource<<8276201c97e0618f58f3cbfe1cc2fcea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedImageGalleryModal_viewer">;
  readonly " $fragmentType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedImageGalleryModal_viewer"
    },
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    },
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "02e8b04955aea9516c735cc6d5ba669b";

export default node;
